import { Dialog, DialogContent, DialogHeader } from "components/app/dialog/dialog";

import { X } from "lucide-react";
import { useState } from "react";
import { RequestApi, RouteApi } from "utils";
import { Service } from "utils/services";

interface DialogProps {
  isDialogOpen: boolean;
  email: string;
  setIsDialogOpen: (value: boolean) => void;
  token: string;
}

export default function DialogOTP({ isDialogOpen, setIsDialogOpen, email, token }: DialogProps) {
  const [otp, setOtp] = useState(Array(4).fill("")); // Assuming 6-digit OTP
  const [isLoading, setIsLoading] = useState(false);
  const [isTrue, setIsTrue] = useState(false);
  const [data, setData] = useState("");

  const onChangeOtp = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.target.value;

    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value === "" && index > 0) {
      newOtp[index] = "";
      setOtp(newOtp);
      document.getElementById(`otp-input-${index - 1}`)?.focus();
    } else {
      // Otherwise, update OTP and move to the next input
      newOtp[index] = value;
      setOtp(newOtp);
      if (index < otp.length - 1 && value) {
        document.getElementById(`otp-input-${index + 1}`)?.focus();
      }
    }
  };
  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Submitting OTP:", otp); // Log OTP before submission
    setIsLoading(true);
    try {
      const url = `${RouteApi.submitVerifyEmailActivation}token=${Service.token}`;
      const data = {
        activation_token: token,
        activation_code: otp.join(""), // Join OTP values
        app_key: Service.appKey,
      };
      const response = await RequestApi(url, { data });
      console.log("response", response);
      if (response.status === "success") {
        setIsDialogOpen(false);
        setIsTrue(false);
      } else {
        setIsTrue(true);
        setOtp(Array(4).fill(""));
        setIsLoading(false);
        setData(response.msg);
      }
      console.log("API called", data);
    } catch (error) {
      console.error("Error during verification:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isDialogOpen} onOpenChange={(open) => setIsDialogOpen(open)}>
      <DialogContent className="custom-dialog-class">
        <DialogHeader>
          <div
            className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
            onClick={() => {
              setIsDialogOpen(false);
              setOtp(Array(4).fill(""));
              setIsTrue(false);
              setData("");
            }}
          >
            <X />
          </div>
        </DialogHeader>
        <div className="flex items-center justify-center overflow-hidden px-5">
          <div className="flex flex-col justify-center overflow-hidden ">
            <div className="relative px-6 pt-10 pb-9 shadow-xl mx-auto w-full max-w-lg rounded-2xl">
              <div className="mx-auto flex w-full max-w-md flex-col space-y-16">
                <div className="flex flex-col items-center justify-center text-center space-y-2">
                  <div className="font-semibold text-3xl">
                    <p>Email Verification</p>
                  </div>
                  <div className="flex flex-row text-sm font-medium text-gray-400">
                    <p>We have sent a code to your email {email}</p>
                  </div>
                </div>
                <form onSubmit={onSubmit}>
                  <div className="flex flex-col space-y-16">
                    <div className="flex items-center justify-between mx-auto w-full max-w-xs">
                      {otp.map((_, index) => (
                        <div key={index} className="w-16 h-16">
                          <input
                            id={`otp-input-${index}`} // Unique ID for focus
                            className={`w-full h-full flex flex-col items-center bg-transparent  justify-center text-center px-5 outline-none rounded-xl border text-lg focus:ring-1 ring-blue-700 
                            ${isTrue ? "border-red-500" : "border-gray-400"}`}
                            type="text"
                            value={otp[index]}
                            onChange={(e) => onChangeOtp(e, index)}
                            maxLength={1}
                            required
                          />
                        </div>
                      ))}
                    </div>
                    <span className=" text-sm text-red-500 flex items-center justify-center ">{data}</span>
                    <div className="flex flex-col space-y-5">
                      <div>
                        <button
                          type="submit"
                          className="flex flex-row items-center justify-center text-center w-full border rounded-xl outline-none py-5 bg-blue-700 border-none text-white text-sm shadow-sm"
                          disabled={isLoading}
                        >
                          {isLoading ? "Verifying..." : "Verify Account"}
                        </button>
                      </div>
                      <div className="flex flex-row items-center justify-center text-center text-sm font-medium space-x-1 text-gray-500">
                        <p>Didn't receive code?</p>
                        <a className="flex flex-row items-center text-blue-600" href="http://" target="_blank" rel="noopener noreferrer">
                          Resend
                        </a>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

